import React, { Component } from 'react';
import { getFileExtension } from 'utils'
import fileSize from 'filesize'
import Icon from 'components/icon/icon'
import Button from 'components/button/button'

import { forIn } from 'lodash'

import DropdownMenu from 'components/dropdown-menu/dropdown-menu'

import { 
    formatByTimeZone,
    getDownloadUrl
} from 'utils'

class FileInfo extends Component {
    uploadFile = (version, previewUrl) => {
        const {
            openModal,
            file
        } = this.props

        const data = {
            file,
            version,
            previewUrl: previewUrl
        }

        openModal('upload', 'task_file', data)
    }

    render(){
        const {
            currentProject,
            file,
            user,
            allTasks,
            updateParentTask,
            deleteFile
        } = this.props

        let selectableTasks = []

        forIn(allTasks, task => {
            if(currentProject.milestones.indexOf(task.milestone_id) !== -1){
                selectableTasks.push(task.id)
            }
        })

        let uploadedString = formatByTimeZone(file.latestVersion.created_at,'Do MMMM')

        if(user){
            uploadedString += ` by ${user.first_name} ${user.last_name}`
        }

        return(
            <table className="file-info-meta">
                <tbody>
                    <tr>
                        <td>
                            <label>
                                Uploaded:
                            </label>
                        </td>
                        <td>
                            <span>
                                { uploadedString }
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label>
                                Filetype:
                            </label>
                        </td>
                        <td>
                            <span>
                                {getFileExtension(file.latestVersion.filename)}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label>
                                Size:
                            </label>
                        </td>
                        <td>
                            <span>
                                {fileSize(file.latestVersion.size)}
                            </span>
                        </td>
                    </tr>
                    <tr className={'download-url'}>
                        <td>
                            <label>
                                Direct URL:
                            </label>
                        </td>
                        <td>
                            <span>
                                <a href={getDownloadUrl(file.latestVersion)} target="_blank">
                                    { getDownloadUrl(file.latestVersion) }
                                </a>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label>
                                Parent task:
                            </label>
                        </td>
                        <td>
                            <span>
                                <DropdownMenu 
                                    allItemEntities={allTasks} 
                                    parentType="task" 
                                    parentKey="task_id" 
                                    selectableItems={selectableTasks} 
                                    selectedItemId={file.task_id} 
                                    handleChange={updateParentTask} 
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className="file-controls" colSpan={2}>
                            <Button
                                size={'small'}
                                level={'high'}
                                callback={(file, previewUrl) => { this.uploadFile(file, previewUrl) }}
                                label={'Upload new version'}
                                icon={'upload'}
                                hasFile={true}
                                disableMultiple={true}
                            />
                            <div className="file-controls-bottom">
                                <button onClick={deleteFile}>
                                    <Icon name={'fe-trash-2'} />
                                    <span>
                                        Delete file
                                    </span>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }
}

export default FileInfo;



// WEBPACK FOOTER //
// ./src/sections/projects/project/project-files/tabs/file-info.jsx